import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon, { NAMES } from '@ifit/react-icons';
import classNames from 'classnames';
import getNavData from '../../../navigation/get-nav-data';

import { white30, solidWhite } from '../../../theme/colors';
import './settings-navigation.css';

export default class SettingsNavigation extends Component {
  static get propTypes() {
    return {
      moveBackward: PropTypes.func.isRequired,
      saveAndMoveForward: PropTypes.func.isRequired,
      totalPages: PropTypes.number,
      hideNavigation: PropTypes.bool,
      navIcons: PropTypes.array,
      mediaType: PropTypes.string,
      appName: PropTypes.string.isRequired,
      flowType: PropTypes.string.isRequired,
      page: PropTypes.string.isRequired,
      isValid: PropTypes.bool.isRequired
    };
  }

  renderNavIcons(navData, page) {
    let iconHasBeenInSpotlight = false;
    const navIcons = navData.icons.map((navIcon) => {
      if (navIcon === navData.iconMapping[page]) iconHasBeenInSpotlight = true;
      const shouldRenderIcon = this.props.mediaType === 'phone' ? navData.iconMapping[page] === navIcon : iconHasBeenInSpotlight;
      const renderedIcon = shouldRenderIcon
        ? (<span className={ classNames('nav-icon-container', { 'active': navData.iconMapping[page] === navIcon }) } key={ navIcon }>
          <Icon
            className="nav-icon"
            name={ NAMES[navIcon] }
            color={ solidWhite }
          />
        </span>)
        : <span className={ classNames('nav-icon-placeholder', { 'faded': !iconHasBeenInSpotlight }) } key={ navIcon } />;

      return renderedIcon;
    });

    return (
      <div className={ classNames('settings-icon-bar', this.props.mediaType) }>
        { navIcons }
      </div>
    );
  }

  renderNavBar(navData) {
    return (
      <div className="settings-progress-bar">
        <span
          className="settings-progress-step"
          style={{
            width: (100 / navData.totalPages) + '%',
            left: ((100 / navData.totalPages) * navData.currentIndex) + '%'
          }}
        />
      </div>
    );
  }

  render() {
    const { appName, flowType, page, hideNavigation } = this.props;

    if (hideNavigation) return null;

    const navData = getNavData(appName, flowType, page);

    return (
      <nav className={ classNames('settings-navigation', this.props.appName, this.props.mediaType) }>
        <div>
          <button
            className={ classNames(navData.currentIndex === 0 ? 'inactive' : null) }
            disabled={ navData.currentIndex === 0 }
            onClick={ this.props.moveBackward }
            color={ navData.currentIndex === 0 ? white30 : solidWhite }
          >
            <Icon
              className="nav-left-arrow"
              name={ NAMES.CHEVRON_LEFT }
              color={ solidWhite }
              size={ 11 }
            />
            Back
          </button>
        </div>
        { navData.icons ? this.renderNavIcons(navData, page) : this.renderNavBar(navData) }
        <div>
          <button
            className={ this.props.isValid ? null : 'inactive' }
            onClick={ this.props.saveAndMoveForward }
            disabled={ !this.props.isValid }
            color={ navData.currentIndex === 0 ? white30 : solidWhite }
          >
            Next
            <Icon
              className="nav-right-arrow"
              name={ NAMES.CHEVRON_RIGHT }
              color={ solidWhite }
              size={ 11 }
            />
          </button>
        </div>
      </nav>
    );
  }
}
